<template>
  <div class="wrapper" :class="{open: open}">
    <review-sidebar/>
    <main role="main">
      <review-navbar/>
      <div id="menu" @click="clickMenu">
        <base-icon name="menu" stroke="rgb(52,58,64)" width="34" height="34" class="nav-link"/>
      </div>
      <router-view :key="$route.fullPath"/>
    </main>
  </div>
  <!--.wrapper -->
</template>

<script>
import ReviewNavbar from '@/components/review/ReviewNavbar.vue'
import ReviewSidebar from '@/components/review/ReviewSidebar.vue'
export default {
  components: { ReviewNavbar, ReviewSidebar },
  data() {
    return {
      open: false
    }
  },
  methods: {
    clickMenu() {
      this.open = !this.open
      // console.log(this.open)
    }
  }
}
</script>

<style lang="scss">
.wrapper {
  left: 0;
  position: relative;
  width: auto;
}

main {
  position: relative;
}
#menu {
  position: absolute;
  top: 0;
  right: 0px;
  cursor: pointer;
}

.open.wrapper {
  left: -320px;
  position: relative;
  width: 100%;

  .sidebar {
    width: 320px;
  }
}
// Small devices (landscape phones, 576px and up)
@media (min-width: 576px) {
  /*...*/
}

// Medium devices (tablets, 768px and up)
@media (min-width: 768px) {
  .sidebar {
    width: 220px;
    display: block;
    font-size: 1em;
  }
  .wrapper {
    margin-right: 220px;
    left: 0px;
    width: auto;
  }
  #menu {
    display: none;
  }
  .open.wrapper {
    margin-right: 220px;
    left: 0px;
    width: auto;

    .sidebar {
      width: 220px;
    }
  }
}
</style>
